<template>
  <footer class="footer">
  <div class="content has-text-centered">
    <div class="parent">
    <p class="left">{{$t('info')}}:<br>
      {{$t('university')}} <br>
      {{$t('address')}}<br>

{{$t('emailAddress')}}</p>
    <p class="left">{{$t('links')}}:<br>
    <a href="https://twitter.com/tufs_swim_team">{{$t('tufs')}}</a> <br>

          <a href="http://web.tuat.ac.jp/~tuatswim/">{{$t('noukou')}}</a>  <br>
          <a href="https://tumsatswimmingteam.wixsite.com/website">{{$t('kaiyou')}}</a>
    </p>
    </div>
    <br>
    <p>
      <a target="_blank" href="https://www.instagram.com/uec_swimteam/" class="fa fa-instagram"></a><a target="_blank" href="https://twitter.com/uecst" class="fa fa-twitter"></a> <br><br>
      Copyright © {{year}} UEC Swimming Team All rights reserved.
    </p>
  </div>
</footer>
</template>

<script>

export default {
  name: 'Footer',
  components: {
  },
  props: {
    year: String
  },
  beforeMount() {
    var d = new Date();
    this.year = d.getFullYear();
  }
}
</script>

<style scoped>
footer {
  padding-left: 25%;
  padding-right: 25%;
  background-color: #0a131b;
  color: white;
}
.left {
  text-align: left;
}
.parent {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.fa {
  width: 40px;
  height: 40px;
  margin: 0px 5px;
  padding-top: 10px;
  font-size: 20px;
  text-align: center;
  text-decoration: none;
  border-radius: 50%;
}
.fa-instagram {
  background: #8134AF;
  color: white;
}
.fa-twitter {
  background: #55ACEE;
  color: white;
}
.fa:hover {
  opacity: 0.7;
}
@media only screen and (max-width: 500px){
    footer {
        padding-left: 5%;
        padding-right: 5%;
    }
}
</style>